import styled from 'styled-components'

const WrapTotals = styled.div`
  #header {
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  #value {
    font-weight: 100;
  }
`
export { WrapTotals }
